import { render, staticRenderFns } from "./basicinfo.vue?vue&type=template&id=ea28f5d2&scoped=true&"
import script from "./basicinfo.vue?vue&type=script&lang=js&"
export * from "./basicinfo.vue?vue&type=script&lang=js&"
import style0 from "./basicinfo.vue?vue&type=style&index=0&id=ea28f5d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea28f5d2",
  null
  
)

export default component.exports